// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Bbnl","inputDescription":"styles_inputDescription__1RqLM"};